const getters = {
  token: state => state.user.token,//用户token
  userInfo: state => state.user.userInfo,//用户信息
}

export default getters